import styled from "styled-components";

export const StyledButton = styled.button`
  display: flex;
  padding: 15px !important;
  justify-content: center !important;
  align-items: center !important;
  border: 1px solid ${({ theme }) => theme.colors.white} !important;
  color: ${({ theme }) => theme.colors.white} !important;
  background: ${({ theme }) => theme.colors.red} !important;
  cursor: pointer !important;
  transition. 0.2s ease-in-out;
  white-space: wrap !important;
  &:hover{
    opacity: 0.7 !important;
  }
  &:disabled{
    cursor: not-allowed !important;
    background: ${({ theme }) => theme.colors.grey1} !important;
    color: ${({ theme }) => theme.colors.black} !important;
  }
`;
